export function validateNewProps(newProps) {
  if (typeof newProps !== 'object' || newProps === null) {
    return {
      valid: false,
      message: 'Please specify new props'
    };
  }

  if (typeof newProps.name !== 'undefined' && !newProps.name) {
    return {
      valid: false,
      message: 'Please specify name'
    };
  }

  if (typeof newProps.folderId !== 'undefined' && !newProps.folderId && newProps.folderId !== null) {
    return {
      valid: false,
      message: 'Please specify folder id'
    };
  }

  if (typeof newProps.parentId !== 'undefined' && !newProps.parentId && newProps.parentId !== null) {
    return {
      valid: false,
      message: 'Please specify parent folder id'
    };
  }

  if (typeof newProps.tags !== 'undefined' && !Array.isArray(newProps.tags)) {
    return {
      valid: false,
      message: 'Tags should be an array'
    };
  }

  return {
    valid: true
  };
}